import { GTMContext, GTMTag } from '../model/google-tag-manager.interface';

export abstract class GTMServiceFactory {
  abstract initializeFromUserInfo(): boolean;
  abstract setContext(context: GTMContext): void;
  abstract getContext(): GTMContext;
  abstract clearContext(): void;
  abstract pushTag(tag: Partial<GTMTag>): void;
  abstract trackCustomEvent(
    eventName: string,
    config?: {
      category?: string;
      action?: string;
      label?: string;
      value?: any;
      additionalData?: Record<string, any>;
    }
  ): void;
  abstract trackPageViewed(
    eventName: string,
    pageName: string,
    additionalData?: Record<string, any>
  ): void;
}
